import React from 'react';
import PropTypes from 'prop-types';
import Chevron from '../../assets/icons/chevron_right.svg';
import cn from 'classnames';
import isExternalLink from '../../util/isExternalLink'
import { navigate } from 'gatsby';

const Button = ({ children, className, as = 'button', ...props }) => {
  const Element = `${as === 'link' ? 'a' : 'button'}`;

  if (props.href) {
    props.onClick = function(e) {
      e.preventDefault();
      if (isExternalLink(props.href)) {
        return window.location.href = props.href
      } else {
        const state = {
          modal: /^(\/stappenplan\/|\/form\/)/.test(props.href),
        }
        return navigate(props.href, { state });
      }
    }
  }

  return (
    <Element className={cn('button', className)} {...props}>
      {children}
      <Chevron />
    </Element>
  );
};

Button.propTypes = {
  // children: PropTypes.string.isRequired,
};

export default Button;
